<!--
 * @Author: guodm guodm@9856
 * @Date: 2023-08-09 09:27:54
 * @LastEditors: guodm guodm@9856
 * @LastEditTime: 2023-08-22 15:39:06
 * @FilePath: \website\src\pages\components\banner.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="banner" v-if="store.isApp" @click="gotoApp">
        <img class="banner-bg" src="@/assets/banner-iphone.png" alt="" srcset="">
    </div>
    <div class="banner" v-else>
        <img class="banner-bg" src="@/assets/banner.jpg" alt="" srcset="">
        <div class="container-banner row no-gutters d-flex justify-content-center">
            <div class="down col-11 col-xl-8">
                <div class="content d-flex align-items-center cursor-pointer">
                    <div class="downDmo"  @click="gotoApp">
                        <span>下载爱华甄选APP</span>
                        <img src="@/assets/arrow.png" alt="" srcset="">
                        
                    </div>
                    <img class="code" src="@/assets/code.png" alt="" srcset="">
                </div>
            </div>
            
        </div>
        <div class="bottom-img row no-gutters d-flex justify-content-center ">
            <img class="col-11 col-xl-8" src="@/assets/serve.png" alt="" srcset="">
        </div>
    </div>
</template>

<script setup>
import { mainStore } from "@/sheep/store"
const store = mainStore()
function gotoApp(){
    if(store.isApp){
        location.href='https://zx-download.aihua.com/'
    }
    
}

</script>

<style lang="scss" scoped>
.banner{
    position:relative;
    padding-top: 8.8rem;
    .banner-bg{
        width:100%;
    }
    .bottom-img{
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 0;
    }
    .container-banner{
        position: absolute;
        bottom: 30%;
        width:100%;
        .downDmo{
            padding: 1vw 2vw;
            background: rgba(224, 46, 36, 1);
            border-radius: 100px;
            display: inline-flex;
            align-items: center;
            color:white;
            font-size: 2.1rem;
            font-weight: 500;
            img{
                height: 2rem;
                margin-left: 0.7rem;
            }
        }
        
        .content{
            width: fit-content;
        }
        .down{
            .code{
                width: 10vw;
                margin-left: 1vw;
                opacity: 0;
                transition: all .4s;
            }
        }
        .content:hover{
            .code{
                opacity: 1;
                transition: all .4s;
            }
            
        }
    }
    @media screen and (max-width: 767px) {
        .container-banner{
            bottom: 11.7188vw;
            .downDmo{
                padding: 2vw;
                font-size: 1.0938vw;
                // img{
                //     height: 1.0417vw;
                //     margin-left: .3646vw;
                // }
            }
            
        }
    }
}

</style>